import { render, staticRenderFns } from "./products9A-classes-maintenance.vue?vue&type=template&id=051cd04e&"
import script from "./products9A-classes-maintenance.vue?vue&type=script&lang=js&"
export * from "./products9A-classes-maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports